import { CommandType } from '@shared/constants/CommandValues';
import { FaceControls } from '@shared/constants/controls/FaceControls';
import { HeadControls } from '@shared/constants/controls/HeadControls';
import { TiltControls } from '@shared/constants/controls/TiltMotionControls';
import DeviceProfileConfiguration from '@shared/models/deviceProfiles/DeviceProfileConfiguration';
import MacroModel from '@shared/models/deviceProfiles/MacroModel';

const hasTiltControls = (macros: MacroModel[]) => {
    return macros.some((macro) => {
        const hasMotion = TiltControls.some((expression) =>
            macro.commands.some((command) => command.includes(expression))
        );
        return hasMotion;
    });
};
const hasHeadControls = (macros: MacroModel[]) => {
    return macros.some((macro) => {
        const hasHead = HeadControls.some((expression) =>
            macro.commands.some((command) => command.includes(expression))
        );
        return hasHead;
    });
};
const hasExpressionControls = (macros: MacroModel[]) => {
    return macros.some((macro) => {
        const hasExpression = FaceControls.some((expression) =>
            macro.commands.some((command) => command.includes(expression))
        );
        return hasExpression;
    });
};

const getProfileFeatures = (profileConfig: DeviceProfileConfiguration) => {
    const features = [] as CommandType[];
    if (profileConfig.hotkeys?.length > 0) features.push('hotkey');
    if (hasTiltControls(profileConfig.macros)) features.push('tilt');
    if (hasHeadControls(profileConfig.macros)) features.push('head');
    if (hasExpressionControls(profileConfig.macros)) features.push('expression');
    if (profileConfig.macros?.length > 0) features.push('voice');
    if (profileConfig.audioEvents?.length > 0) features.push('spoken');
    return features;
};

export default getProfileFeatures;
